import React from 'react';
import { GitBranch } from 'lucide-react';
import { cn } from '../../lib/utils';

export default function BranchLabel({ name, show = false, className = '' }) {
  if (!show || !name) return null;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full bg-muted px-2 py-0.5 text-xs text-muted-foreground shrink-0',
        className,
      )}
      title={`Branch: ${name}`}
    >
      <GitBranch className="h-3 w-3 shrink-0" />
      <span className="truncate max-w-[8rem]">{name}</span>
    </span>
  );
}
